'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = exports.pv = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _b2a = require('b2a');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackingData = function () {
  function TrackingData(data) {
    (0, _classCallCheck3.default)(this, TrackingData);

    this._data = data;
    // data.r = document.referrer
    data.t = +new Date();
    // data.m = cookie.get('ac')
  }

  (0, _createClass3.default)(TrackingData, [{
    key: 'toString',
    value: function toString() {
      return (0, _b2a.btoa)((0, _stringify2.default)(this._data));
    }
  }]);
  return TrackingData;
}(); // import axios from '@beastshop/axios'
// import cookie from 'js-cookie'
// import qs from 'query-string'
// import debounce from 'lodash.debounce'


function _track(tp, m, p, r, a, n) {
  var trackData = new TrackingData({
    n: n,
    p: p,
    r: r,
    // t
    m: m,
    tp: tp,
    a: a
  });
  return trackData.toString();
}

var pv = exports.pv = function pv(markting, page, referrer) {
  return _track('v', markting, page, referrer);
};

var track = exports.track = function track(_ref) {
  var name = _ref.name,
      markting = _ref.markting,
      page = _ref.page,
      referrer = _ref.referrer,
      _ref$attrs = _ref.attrs,
      attrs = _ref$attrs === undefined ? {} : _ref$attrs;

  if (!name) {
    throw new Error('tracker: name must not be empty');
  }

  return _track('a', markting, page, referrer, attrs, name);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/tracker/lib/index.js
// module id = 852
// module chunks = 0